import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "../components/ui/Card";
import { Button } from "../components/ui/Button";
import { Input } from "../components/ui/Input";
import { Spinner } from "../components/ui/Spinner";
import { useAuthStore, getStoredRealmConfig } from "../stores/authStore";

function hasKeycloakCallback() {
  const searchParams = new URLSearchParams(window.location.search);
  const hashParams = new URLSearchParams(window.location.hash.slice(1));
  return (searchParams.has("code") && searchParams.has("state")) ||
    (hashParams.has("code") && hashParams.has("state"));
}

export default function LoginPage() {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading, error, loginWithEmail, init } = useAuthStore();
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [status, setStatus] = useState("");

  useEffect(() => {
    async function completeCallback() {
      if (!hasKeycloakCallback() || !getStoredRealmConfig()) return;
      setStatus("Completing login...");
      try {
        await init();
      } catch (err) {
        setStatus(err.message || "Login failed");
      }
    }

    completeCallback();
  }, [init]);

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/domains", { replace: true });
    }
  }, [isAuthenticated, navigate]);

  async function handleSubmit(event) {
    event.preventDefault();
    setSubmitting(true);
    setStatus("Finding your network...");
    try {
      await loginWithEmail(email);
    } catch (err) {
      setStatus(err.message || "Unable to start login");
      setSubmitting(false);
    }
  }

  const busy = isLoading || submitting;

  return (
    <div className="flex min-h-[calc(100vh-4rem)] items-center justify-center">
      <Card className="w-full max-w-md">
        <CardHeader className="space-y-1">
          <CardTitle className="text-2xl text-center">Sign in</CardTitle>
          <CardDescription className="text-center">
            Use your account email to find your network.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <Input
              type="email"
              autoComplete="email"
              placeholder="you@example.com"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              disabled={busy}
              required
            />
            <Button type="submit" className="w-full" disabled={busy}>
              {busy ? <Spinner className="h-4 w-4 mr-2" /> : null}
              Continue
            </Button>
            {(status || error) && (
              <p className={`text-sm text-center ${error || status.includes("failed") || status.includes("Unable") ? "text-red-500" : "text-slate-500"}`}>
                {error || status}
              </p>
            )}
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
